export const sendAjax = function (url, params, callback) {
    $.ajax({
        url: url,
        type: 'post',
        cache: false,
        processData: false,
        contentType: false,
        data: params
    }).done(function (data) {
        const dataObj = JSON.parse(data)
        if (dataObj.success && !dataObj.errors) {
            callback && callback(dataObj);
        } else {
            callback && callback(dataObj);
        }
    }).fail(function (xhr, status, error) {
        console.error('AJAX error:', error);
    });
};
